import Navbar from "../NavBar";
import SideBar from "../SideBar";
import AdminNavbar from "./AdminNavBar";

export interface IAdminContainer {
    children: React.ReactNode;
}

export default function AdminContainer({children}: IAdminContainer) {
    /*return(
        <div className={' md:overflow-hidden bg-system-blue-dark '}>
            <Navbar/>
            <div className={`flex w-full ${list ? 'md:h-[calc(95vh_-_50px)]' : ''} overflow-auto overflow-hidden justify-center`}>
                <div className={'md:w-container xs:w-full  px-3 pt-5 max-h-full overflow-auto scrollbar'}>
                    {children}
                </div>
            </div>
        </div>
    )*/
    return(
        <div className={'md:h-screen md:overflow-hidden bg-system-blue-dark '}>
            <AdminNavbar/>
            <div className={'flex w-full md:h-full overflow-hidden'}>
                <SideBar/>
                <div className={'md:w-container xs:w-full  px-3 pt-5  overflow-auto scrollbar'}>
                    {children}
                </div>
            </div>
        </div>
    )
}